// extracted by mini-css-extract-plugin
export var notificationHost = "_jm-0";